<template>
  <div id="root">
    <DepthChart />
  </div>
</template>
<script>
import DepthChart from '../../components/DepthChart/DepthChart';

export default {
    components: {
        DepthChart
    }
};
</script>
